import { render, staticRenderFns } from "./LocationAddNew.vue?vue&type=template&id=a4aa9182&scoped=true&"
import script from "./LocationAddNew.vue?vue&type=script&lang=js&"
export * from "./LocationAddNew.vue?vue&type=script&lang=js&"
import style0 from "./LocationAddNew.vue?vue&type=style&index=0&id=a4aa9182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aa9182",
  null
  
)

export default component.exports